import { usePotentialBookingFiltersContext } from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import { DateRangeSelection } from '@shared/components'
import React from 'react'

export const DateFilter = () => {
  const { createdAtEndDate, createdAtStartDate, setFilters } = usePotentialBookingFiltersContext()
  return (
    <div className="relative flex flex-col hidden w-full md:w-auto lg:flex">
      <DateRangeSelection
        endDate={createdAtEndDate}
        headerTitle="Created Date"
        listFilter={true}
        pastSelection={true}
        setEndDate={(d?: Date) => {
          setFilters({ createdAtEndDate: d })
        }}
        setStartDate={(d?: Date) => {
          setFilters({ createdAtStartDate: d })
        }}
        startDate={createdAtStartDate}
      />
    </div>
  )
}
